import React from 'react';
import '../styles/Hero.scss';

const Hero = ({ project }) => {
  return (
    <div className="Hero">
      <img src={project.hero.bgImage} alt={project.title} />
      <div className="bottom-border" />
      <style type="text/css">
        {`
          .Hero {
            background-image: url(${project.hero.bgImage});
            background-position: center ${project.hero.bgPosition};
          }
        `}
      </style>
    </div>
  );
};

Hero.propTypes = {
  project: React.PropTypes.object.isRequired
};

export default Hero;



// WEBPACK FOOTER //
// ./src/components/Hero.js